import { CheckCircle2 } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { useLanguage } from "@/context/LanguageContext";
import { ordersLabels } from "@/i18n";

interface PurchaseStatusProps {
  purchaseDate?: string;
  paymentDate?: string;
}

export const PurchaseStatus = ({
  purchaseDate,
  paymentDate,
}: PurchaseStatusProps) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  const { language } = useLanguage();
  const L = ordersLabels(language);

  return (
    <div className="space-y-6">
      {purchaseDate && (
        <div className="flex items-center gap-3">
          <CheckCircle2 className="w-5 h-5 text-blue-400" />
          <div>
            <div
              className={`font-semibold ${
                isDark ? "text-white/80" : "text-black"
              }`}
            >
              {(L as any).purchaseDate ?? "Inköpsdatum"}
            </div>
            <div className={isDark ? "text-white/80" : "text-black/80"}>
              {purchaseDate}
            </div>
          </div>
        </div>
      )}

      {paymentDate && (
        <div className="flex items-center gap-3 pt-4">
          <CheckCircle2 className="w-5 h-5 text-green-400" />
          <div>
            <div
              className={`font-semibold ${
                isDark ? "text-white/80" : "text-black"
              }`}
            >
              {(L as any).paymentReceived ?? "Betalning mottagen"}
            </div>
            <div className={isDark ? "text-white/80" : "text-black/80"}>
              {paymentDate}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
